module.exports = __webpack_public_path__ + "static/media/bell-solid.e41747ad.svg";